import React from "react";
// import "react-phone-number-input/style.css";
// import PhoneInput from "react-phone-number-input";
import {
  DialogContent,
  Grid,
  TextField,
  Button,
  DialogActions,
  Box,
  DialogTitle,
  Checkbox,
} from "@material-ui/core";
import { LoadingComponent } from "../../components/Loading";

export const SignupForm = ({ formik, isLoading, closeModal }) => {
  return (
    <Box>
      <DialogTitle>Sign up</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container direction="row" spacing={3}>
            <Grid item md>
              <TextField
                id="firstname"
                label="First Name"
                value={formik.values.firstname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoFocus
                fullWidth
                helperText={
                  formik.touched.firstname ? formik.errors.firstname : ""
                }
                error={!!formik.touched.firstname && !!formik.errors.firstname}
              />
            </Grid>
            <Grid item md>
              <TextField
                id="lastname"
                label="Last Name"
                value={formik.values.lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                helperText={
                  formik.touched.lastname ? formik.errors.lastname : ""
                }
                error={!!formik.touched.lastname && !!formik.errors.lastname}
              />
            </Grid>
          </Grid>

          <Grid container direction="row" spacing={3}>
            <Grid item md>
              <TextField
                id="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                helperText={formik.touched.email ? formik.errors.email : ""}
                error={!!formik.touched.email && !!formik.errors.email}
              />
            </Grid>

            {/* <Grid item md>
              
              <TextField
                id="phone"
                label="Telefonnummer"
                type="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                fullWidth
                helperText={formik.errors.phone}
                error={!!formik.errors.phone}
              />
            </Grid> */}
            <Grid item md>
              <TextField
                id="company"
                label="Company"
                value={formik.values.company}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                helperText={formik.touched.company ? formik.errors.company : ""}
                error={!!formik.touched.company && !!formik.errors.company}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={3}>
            <Grid item md>
              <TextField
                id="password"
                label="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="password"
                fullWidth
                helperText={
                  formik.touched.password ? formik.errors.password : ""
                }
                error={!!formik.touched.password && !!formik.errors.password}
              />
            </Grid>
            <Grid item md>
              <TextField
                id="confirmPassword"
                label="Confirm Password"
                type="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                fullWidth
                helperText={
                  formik.touched.confirmPassword
                    ? formik.errors.confirmPassword
                    : ""
                }
                error={
                  !!formik.touched.confirmPassword &&
                  !!formik.errors.confirmPassword
                }
              />
            </Grid>
          </Grid>
          <Box mt={2}>
            <Checkbox
              id="terms"
              name="terms"
              color="primary"
              value={formik.values.terms}
              onChange={formik.handleChange}
              style={{ paddingLeft: 0 }}
              error={formik.errors.terms}
              required
            />
            I read and agree with{" "}
            <a href="http://faktual.de/terms" target="_blank">
              Faktual‘s Terms of Service
            </a>
          </Box>
          <DialogActions>
            <Button color="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              {isLoading ? <LoadingComponent width="50px" /> : "Signup"}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Box>
  );
};
